import { render, staticRenderFns } from "./TeacherList.vue?vue&type=template&id=1db54e5f&"
import script from "./TeacherList.vue?vue&type=script&lang=ts&"
export * from "./TeacherList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports